module.exports = __webpack_public_path__ + "static/media/sculptureDefault.c3f6959c.png";